/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ zone: NonNullable<unknown>, time: NonNullable<unknown>, percent: NonNullable<unknown> }} Ui_More_Stats_Zone_AriaInputs */

const en_ui_more_stats_zone_aria = /** @type {(inputs: Ui_More_Stats_Zone_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.zone}: ${i?.time} · ${i?.percent} %`)
};

const de_ui_more_stats_zone_aria = /** @type {(inputs: Ui_More_Stats_Zone_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.zone}: ${i?.time} · ${i?.percent} %`)
};

/**
* | output |
* | --- |
* | "{zone}: {time} · {percent} %" |
*
* @param {Ui_More_Stats_Zone_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_zone_aria = /** @type {((inputs: Ui_More_Stats_Zone_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Zone_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_zone_aria(inputs)
	return de_ui_more_stats_zone_aria(inputs)
});